import { ModelBase } from '../../core/model/model-base';
import { PropertyTaxRentalChangeModel } from './property-tax-rental-change';
import { Article } from './article';
import {
  ColdWaterPaymentKind,
  HeatingPaymentKind,
  HotWaterPaymentKind,
  HouseholdElectricityPaymentKind,
  ParkingElectricityPaymentKind,
  PropertyTaxCalculationBasis,
  PropertyTaxCalculationMethod,
  PropertyTaxPaidBy,
} from './const/enums';
import { TaxTypeCode } from './tax-type-code';

export class LeaseAgreementTemplate extends ModelBase {
  constructor() {
    super();
    this.noticePeriodLandlord = 3;
    this.noticePeriodTenant = 3;
    this.invoicePeriodMonths = 1;
    this.heatingPayment = HeatingPaymentKind.IncludedInTheRent;
    this.coldWaterPayment = ColdWaterPaymentKind.IncludedInTheRent;
    this.hotWaterPayment = HotWaterPaymentKind.IncludedInTheRent;
    this.householdElectricityPayment = HouseholdElectricityPaymentKind.SeparateSubscription;
    this.parkingElectricityPayment = ParkingElectricityPaymentKind.IncludedInTheRent;
    this.parkingChargingElectricityPayment = ParkingElectricityPaymentKind.IncludedInTheRent;
  }
  noticePeriodTenant: number;
  noticePeriodLandlord: number;
  invoicePeriodMonths: number;
  specialTerms: string;
  heatingPayment: number;
  coldWaterPayment: number;
  hotWaterPayment: number;
  householdElectricityPayment: number;
  parkingElectricityPayment: number;
  parkingChargingElectricityPayment: number;
  propertyTaxPaidBy: PropertyTaxPaidBy;
  propertyTaxCalculationBasis: PropertyTaxCalculationBasis;
  propertyTaxPercentage: number;
  propertyTaxCalculationMethod: PropertyTaxCalculationMethod;
  propertyTaxAssessmentUnitType: Map<number, TaxTypeCode>;
  propertyTaxArticleId: string;
  propertyTaxRetroArticleId: string;
  propertyTaxArticles: Article[];
  propertyTaxRentalChange: PropertyTaxRentalChangeModel;
}
